import React, { Component } from 'react';
import Webcam from 'react-webcam';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import * as util from '../../utils/util';
import Api from '../../utils/api';

import './Picture.css';

let CaptureButton = styled.button`
transition: background-color 0.2s;
border: 1px solid rgba(147, 128, 108, 0.75);
//background: hsla(31, 15%, 50%, 0.55);
background-color: inherit;
color: inherit;
border-radius: 50%;
cursor: pointer;
font-size: 1em;
font-weight: 500;
text-decoration: none;
white-space: nowrap;
padding: 0.7em;
align-self:center;
margin-top:0
margin-bottom: 10px;
box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
0 1px 5px 0 rgba(0, 0, 0, 0.12),
0 3px 1px -2px rgba(0, 0, 0, 0.2);
transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);

`;

let imgStyleCamera = {
    height: '3em',
    width: 'auto',
    padding: '0 !important',
    margin: '0 !important',
    borderRadius: '50%',
    verticalAlign:'middle'
};

const FormWrapper = styled.div`
width:100%;
`;

const CameraWrapper = styled.div`
width:100%;
`;

const InputAddOn = styled.div`
width:100%;
`;

const InputAddOnColumn = styled.div`
width:100%;
`;

const InputAddOnItem = styled.span`
border: 1px solid rgba(147, 128, 108, 0.75);
padding: 6.5px 0.75em;
background-color: rgba(147, 128, 108, 0.0);
color: #666666;
font: inherit;
font-weight: normal;
&:not(:last-child) {
    border-right: 0;
}
&:first-child {
    border-radius: 2px 0 0 2px;
}
&:last-child {
    border-radius: 0 2px 2px 0;
}
`;

const InputAddOnFile = styled.div`
flex: 1;
flex-direction:row;
align-items:center;
justify-content:center;
border: 1px solid rgba(147, 128, 108, 0.75);
padding: 7.5px 0.7em;
font-size: 1em;

font-weight: 400;
&:not(:first-child) {
    border-left: 1;
    &:first-child {
        border-radius: 2px 0 2px 2px;
    }
    &:last-child {
        border-radius: 0 2px 2px 2px;
    }
}
`;

class Picture extends Component {
    constructor(props) {
        super(props);

        this.handleCapture = this.handleCapture.bind(this);
        this.renderUpload = this.renderUpload.bind(this);
        this.renderCamera = this.renderCamera.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
        this.handleRenderCamera = this.handleRenderCamera.bind(this);
        this.handleCancelCamera = this.handleCancelCamera.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleUploadCancel = this.handleUploadCancel.bind(this);
        this.renderMyPhoto = this.renderMyPhoto.bind(this);
        this.renderInitial = this.renderInitial.bind(this);
        this.handleStartOver = this.handleStartOver.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
        this.handleUploadLocal = this.handleUploadLocal.bind(this);

        this.state = {
            showCam: false,
            skipPicture: false,
            finished: false,
            reviewComplete:false,
            showReview:false,
            showMyPhoto: false,
            showUpload:false,
            showChoice: false,
            saveMyPhoto:false,
            renderInitial: true,
            haveFile:false,
            isLoading:false,
            showText: this.props.showText,
            imageType:'',
        }
    }

    componentDidMount(){
        // ReactGA 配合谷歌跟踪
        try {
          let skinQuizType = this.props.skinQuizType;
          if(skinQuizType)
          Api.eventTrackingStageProgress(skinQuizType.replace("SQ_",""));
        } catch (error) {}

         // 进度条
        try {
            if(this.props.fun_updateStage){
            var stage = this.props.stage;
            var stageSum = this.props.stageSum;
            if(stage && stageSum)
            this.props.fun_updateStage(parseInt(stage)-1,stageSum);
            }
        } catch (error) {
            console.error(error);
        }

    }

    componentWillMount() {
        this.setState({ renderInitial:true });
        
    }

    handleCapture(){
        this.capture();
    }

    setRef = (webcam) => {
        this.webcam = webcam;
    };

    capture = () => {
        const imageSrc = this.webcam.getScreenshot();
        if(imageSrc) {
            this.imgSrc = imageSrc;
            this.setState({
                showCam:false,
                imageType:'webcam',
                showMyPhoto:true
            });
        }
    };

    handleComplete() {
        this.setState({
            showMyPhoto:false,
            finished:true
        },()=>{
            try {
                let pictureResultZom = document.getElementById("picture-result-show");
                pictureResultZom.parentNode.style.backgroundColor = '#9797971a';
                pictureResultZom.parentNode.style.marginLeft = 'auto';
                pictureResultZom.parentNode.style.flexBasis = 'initial';
                pictureResultZom.parentNode.style.textAlign = 'center';
                pictureResultZom.parentNode.previousElementSibling.innerHTML = "";

            } catch (error) {
                console.error(error);                
            }
        });
        let filename = Api.getUUID()  + '.jpg';
        const bucket = this.props.isAth ? process.env.REACT_APP_S3_BUCKET_USER_SELFIE_ATH : process.env.REACT_APP_S3_BUCKET_USER_SELFIE; 
        Api.s3ImageUpload(this.imgSrc, filename, 'image/jpeg', bucket);
        // TODO: optimize
        let imageUrlPrefix = 'https://helloava-prod.s3.us-east-2.amazonaws.com/user-selfie/';
        if (process.env.REACT_APP_ENV === 'dev') {
            imageUrlPrefix = 'https://helloava-dev.s3.us-east-2.amazonaws.com/user-selfie/';
        }
        localStorage.setItem("SQ_picture",imageUrlPrefix + filename);
        try {
            if(this.props.fun_updateStage){
              var stage = this.props.stage;
              var stageSum = this.props.stageSum;
              if(stage && stageSum)
              this.props.fun_updateStage(stage,stageSum);
            }
          } catch (error) {
            console.error(error);
        }
        try {
            let step = this.props.step;
            localStorage.setItem("doneQuizStepId",step.id);
        } catch (error) {
            console.error(error);
        }

        this.props.triggerNextStep({ value: imageUrlPrefix + filename });
    }

    handleSkip() {
        this.setState({
            renderInitial:false,
            showResults:true,
            finished:true
        },()=>{
            try {
                let pictureResultZom = document.getElementById("picture-result-show");
                pictureResultZom.parentNode.style.backgroundColor = '#9797971a';
                pictureResultZom.parentNode.style.marginLeft = 'auto';
                pictureResultZom.parentNode.style.flexBasis = 'initial';
                pictureResultZom.parentNode.style.textAlign = 'center';
                pictureResultZom.parentNode.previousElementSibling.innerHTML = "";
            } catch (error) {
                console.error(error);
            }
        });
        localStorage.setItem("SQ_picture",'Skipped photo');

        try {
            let step = this.props.step;
            localStorage.setItem("doneQuizStepId",step.id);
        } catch (error) {
            console.error(error);
        }

        try {
            if(this.props.fun_updateStage){
              var stage = this.props.stage;
              var stageSum = this.props.stageSum;
              if(stage && stageSum)
              this.props.fun_updateStage(stage,stageSum);
            }
          } catch (error) {
            console.error(error);
        }

        this.props.step.value = "Skipped photo";
        this.props.triggerNextStep({value: 'Skipped photo'});
    }

    handleStartOver() {
        this.setState({
            showMyPhoto:false,
            renderInitial:true,
            imageType:'',
        });
    }

    renderInitial() {
        return this.handleUpload();
    }


    handleUpload() {
        this.setState(
            {
                renderInitial:false,
                showUpload:true
            }
        );
    }

    handleUploadCancel() {
        this.setState(
            {
                renderInitial:true,
                showUpload:false
            }
        );
    }

    renderUpload() {
        return(
            <div style={{width:'100%'}}>

                <div className="onb-item-container">
                    <div className="onb-text-conten">{this.state.showText}</div>
                    <div className="conten-wrap selfie-zone picture-se-but">

                        <button className="p-a-n-button" onClick={()=>{this.handleRenderCamera()}}>Open camera</button>

                        <div className="uploadLocal-container">
                            <button className="p-a-n-button"  >Upload from local</button>
                            <input onChange={this.handleUploadLocal} type="file" accept='.jpg, .png, .gif' ref="file"  name='picture' style={{opacity:'0'}}/>
                        </div>

                        <a className="skip-photo-a-sty" onClick={this.handleSkip}>
                            <span>I changed my mind.</span>
                            <span>Skip photo</span>
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    handleRenderCamera() {
        this.setState(
            {
                showUpload:false,
                showCam:true
            }
        );
    }

    handleCancelCamera() {
        this.setState(
            {
                showUpload:true,
                showCam:false,
                imageType:'',
            }
        );
    }

    renderCamera() {
        return(
            <div style={{width:'100%'}}>
                    <div className="canera-bg-contain">
                        <Webcam audio={false}
                            height={450}
                            ref={this.setRef}
                            screenshotFormat="image/jpeg"
                            width={'100%'}/>
                    </div>
                    <div className="conten-wrap selfie-zone picture-se-but" style={{marginBottom:'10px'}}>
                        <button className="p-a-n-button" onClick={this.capture}>Take photo</button>
                        <button className="p-a-n-button" onClick={this.handleCancelCamera}>Cancel</button>
                    </div>
            </div>
        );
    }

    handleUploadLocal(e) {
        const imageSrc = e.target.files[0];
        if (imageSrc) {
            this.setState({
                isLoading:true
            });
            let reader = new FileReader();
            reader.readAsDataURL(imageSrc);
            reader.onloadend = (evt) => {
                this.imgSrc = reader.result;
                this.setState({
                    showUpload: false,
                    isLoading:false,
                    showMyPhoto: true
                });
            }
        }
        // else {
        //     alert("No photo selected");
        // }
    }

    renderResults() {
        let ResultsContainer = styled.div`
        border-radius: 18px;
        overflow: hidden;
        `;

        if(this.imgSrc) {
            return(
                <div className="onb-item-container" id="picture-result-show">
                    <div className="conten-wrap selfie-zone picture-se-but">
                        <ResultsContainer>
                            <img style={{ maxWidth: '350px', maxHeight: '350px' }} src={this.imgSrc} alt={`Capture`}/>
                        </ResultsContainer>
                    </div>
                </div>
            )
        }else{
            return(
                <div className="onb-item-container" id="picture-result-show">
                    <div className="onb-text-conten">I changed my mind. Skip photo</div>
                </div>
            )
        }
        return null;
    }

    renderMyPhoto() {
        return(
            <InputAddOnColumn>
                <InputAddOn>
                    <img className="myPhoto-img-tyle" src={this.imgSrc} alt={`Capture`}/>
                </InputAddOn>

                <div className="conten-wrap selfie-zone picture-se-but" style={{marginBottom:'10px'}}>
                    <button onClick={this.handleComplete} className="p-a-n-button">Save</button>
                    <button onClick={this.handleStartOver} className="p-a-n-button">
                        {this.state.imageType == 'webcam' ? 'Retake photo': 'Cancel'  }
                    </button>
                </div>
                
            </InputAddOnColumn>
        );
    }

    render() {
        if (this.state.finished) {
            return (
                this.renderResults()
            )
        }

        if (this.state.renderInitial) {
            return (
                <FormWrapper>
                    {this.renderInitial()}
                </FormWrapper>
            )

        }

        if (this.state.showCam) {
            return (
                <CameraWrapper>
                    {this.renderCamera()}
                </CameraWrapper>
            )

        }

        if (this.state.showUpload) {
            return (
                <FormWrapper>
                    {this.renderUpload()}
                </FormWrapper>
            )
        }

        if (this.state.showMyPhoto) {
            return (
                <FormWrapper>
                    {this.renderMyPhoto()}
                </FormWrapper>
            )
        }
    }
}

export default Picture;



// WEBPACK FOOTER //
// ./src/views/onboarding/Picture.js